import { render, staticRenderFns } from "./member-upgrade_page.vue?vue&type=template&id=904fc8b2&scoped=true"
import script from "./member-upgrade_page.vue?vue&type=script&lang=js"
export * from "./member-upgrade_page.vue?vue&type=script&lang=js"
import style0 from "./member-upgrade_page.vue?vue&type=style&index=0&id=904fc8b2&prod&lang=scss&scoped=true"
import style1 from "./member-upgrade_page.vue?vue&type=style&index=1&id=904fc8b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904fc8b2",
  null
  
)

export default component.exports